import { FileSpreadsheet, FileText, Printer } from "lucide-react";

export type ExportFormat = "csv" | "excel" | "pdf";

const FORMATS = [
  ["csv", FileText, "CSV"],
  ["excel", FileSpreadsheet, "Excel"],
  ["pdf", Printer, "PDF"],
] as const;

/** "Export  CSV · Excel · PDF" above a register; what's downloaded is the caller's filtered rows. */
export function ExportButtons({
  onExport,
  disabled,
  busy,
  what = "the filtered list",
  formats,
}: {
  onExport: (format: ExportFormat) => void;
  disabled?: boolean;
  /** Shows "Preparing export…" and holds the buttons while rows are fetched. */
  busy?: boolean;
  what?: string;
  /** Just these, e.g. the CSV and PDF a server report is issued in. */
  formats?: ExportFormat[];
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs font-medium text-gray-500">Export</span>
      {FORMATS.filter(([format]) => !formats || formats.includes(format)).map(([format, Icon, label]) => (
        <button
          key={format}
          type="button"
          className="pager-button h-8"
          disabled={disabled || busy}
          onClick={() => onExport(format)}
          title={`Download ${what} as ${label}`}
        >
          <Icon className="h-3.5 w-3.5" /> {label}
        </button>
      ))}
      {busy && <span className="text-xs text-gray-500">Preparing export…</span>}
    </div>
  );
}
